import React, { useContext } from "react";
import styled from "styled-components";
import { DataContext } from "../../contexts/DataContext";
import Panel from "../UI/Panel/Panel";
import PanelContent from "../UI/Panel/PanelContent";
import PanelTitle from "../UI/Panel/PanelTitle";
import { Button } from "../../Theme/Hyper";
import SelectUI from "../UI/Form/SelectUI";
import { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import ConfirmModal from "../Modals/ConfirmModal";

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
  > tbody > tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
  }

  th {
    padding: 10px;
    border-top: 1px solid #dee2e6;
  }
  td {
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    width: ${(props) => props.width};
    padding: 0px;
    padding-left: 10px;
    padding-right: 10px;
    border-top: 1px solid #dee2e6;
    white-space: nowrap;

    font-size: 0.8em;
  }

  > tbody > tr > td:hover {
    background-color: #14ec8e;
    color: white;
    cursor: pointer;
  }
  > tbody > tr > td.position {
    width: 105px;
  }
  > tbody > tr > td.position:hover {
    color: black;
  }
  > tbody > tr.subs > td {
    border-top: 1px solid black;
  }

  > tbody > tr > td.stat {
    width: 70px;
    max-width: 70px;
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  }
  th.stat {
    width: 70px;
    max-width: 70px;
    padding-left: 0px;
    padding-right: 0px;
    text-align: center;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;
const Spacer = styled.div`
  min-height: 50px;
`;

const TooltipText = styled.span`
  visibility: hidden;
  width: 120px;
  background-color: #202731;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 10000;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
`;

const TH = styled.th`
  border-top: 0;
  border-bottom: 0;
  font-weight: 800;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #343a40;
  text-align: left;
  :hover ${TooltipText} {
    visibility: visible;
    opacity: 1;
  }
`;
const Tooltip = styled.div`
  position: relative;
  display: inline-block;
`;

const POSITIONS = {
  "Goal Shooter": "GS",
  "Goal Attack": "GA",
  "Wing Attack": "WA",
  Centre: "C",
  "Wing Defence": "WD",
  "Goal Defence": "GD",
  "Goal Keeper": "GK",
};

const POSITIONS_SORT = {
  "Goal Shooter": 7,
  "Goal Attack": 6,
  "Wing Attack": 5,
  Centre: 4,
  "Wing Defence": 3,
  "Goal Defence": 2,
  "Goal Keeper": 1,
};

const Row = styled.div`
  display: flex;
`;
const ScoresByQ = styled.div`
  justify-content: end;
  width: 100%;
  display: flex;
`;
const ScoreByQItem = styled.div`
  width: 80px;
  display: flex;
  text-align: center;
  justify-content: center;
  border: 1px solid #ebebeb;
  height: 25px;
`;
const CATEGORIES = {
  goals: "Goals",
  missed_shots: "Missed shots",
  penalties: "Penalties",
  rebounds_offensive: "Offensive rebounds",
  rebounds_defensive: "Defensive rebounds",
  intercepts: "Intercepts",
  deflections: "Deflections",
  turnovers: "Turnovers",
  unforced_errors: "Unforced errors",
};
const QButton = styled(Button)`
  height: 40px;
  min-width: 100px;
`;
const SubButton = styled(Button)`
  width: 80px;
`;

// Hook
function useLocalStorage(key, initialValue) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(() => {
    try {
      // Get from local storage by key
      const item = window.localStorage.getItem(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return initialValue;
    }
  });

  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to localStorage.
  const setValue = (value) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.log(error);
    }
  };

  return [storedValue, setValue];
}

let local_scores_by_quarter;
function Logging({ game }) {
  const { updatePlayerStats, updateLineup, updateGame } =
    useContext(DataContext);
  const [quarter, setQuarter] = useLocalStorage("quarter_" + game?._id, 1);
  const [supershot, setSupershot] = useLocalStorage(
    "supershot_" + game?._id,
    false,
  );
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [homePlayerStats, setHomePlayerStats] = useState();
  const [awayPlayerStats, setAwayPlayerStats] = useState();
  return (
    <Panel style={{ marginTop: "1em" }}>
      <PanelTitle title={"Logging"}>
        <Button
          onClick={async () => {
            setConfirmDelete(true);
          }}
        >
          Clear Data
        </Button>
      </PanelTitle>
      <PanelContent>
        <Column>
          {game?.competition?.number_of_periods === 2 && (
            <Row>
              <QButton
                green={quarter === 1}
                onClick={() => {
                  setQuarter(1);
                }}
              >
                1st Half
              </QButton>
              <QButton
                green={quarter === 2}
                onClick={() => {
                  setQuarter(2);
                }}
              >
                2nd Half
              </QButton>
              <QButton
                green={quarter === 5}
                onClick={() => {
                  setQuarter(5);
                }}
              >
                Extra Time
              </QButton>
            </Row>
          )}
          {game?.competition?.number_of_periods !== 2 && (
            <Row>
              {new Array(game?.competition?.number_of_periods)
                .fill(1)
                .map((_, index) => {
                  return (
                    <QButton
                      green={quarter === index + 1}
                      onClick={() => {
                        setQuarter(index + 1);
                        setSupershot(false);
                      }}
                    >
                      Q{index + 1}
                    </QButton>
                  );
                })}
              <QButton
                green={quarter === 5}
                onClick={() => {
                  setQuarter(5);
                  setSupershot(false);
                }}
              >
                Extra Time
              </QButton>
            </Row>
          )}
          {game?.competition?.number_of_periods === 2 && (
            <Row>
              <Row>
                <QButton
                  green={supershot === false}
                  onClick={() => {
                    setSupershot(false);
                  }}
                >
                  Regular Play
                </QButton>
                <QButton
                  green={supershot}
                  onClick={() => {
                    setSupershot(true);
                  }}
                >
                  SuperShot
                </QButton>
              </Row>
              <ScoresByQ>
                <Column>
                  <ScoreByQItem></ScoreByQItem>
                  <ScoreByQItem>{game?.home_team?.code}</ScoreByQItem>
                  <ScoreByQItem>{game?.away_team?.code}</ScoreByQItem>
                </Column>
                <Column>
                  <ScoreByQItem>1st Half</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.first}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.first}
                  </ScoreByQItem>
                </Column>
                <Column>
                  <ScoreByQItem>2nd Half</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.second}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.second}
                  </ScoreByQItem>
                </Column>

                <Column>
                  <ScoreByQItem>ET</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.fith}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.fith}
                  </ScoreByQItem>
                </Column>
                <Column>
                  <ScoreByQItem>Goals</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.goals}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.goals}
                  </ScoreByQItem>
                </Column>
              </ScoresByQ>
            </Row>
          )}
          {game?.competition?.number_of_periods !== 2 && (
            <Row>
              <Row style={{ alignItems: "center" }}>
                <QButton
                  green={supershot === false}
                  onClick={() => {
                    setSupershot(false);
                  }}
                >
                  Regular Play
                </QButton>
                <QButton
                  green={supershot}
                  onClick={() => {
                    setSupershot(true);
                  }}
                >
                  SuperShot
                </QButton>
              </Row>
              <ScoresByQ>
                <Column>
                  <ScoreByQItem></ScoreByQItem>
                  <ScoreByQItem>{game?.home_team?.code}</ScoreByQItem>
                  <ScoreByQItem>{game?.away_team?.code}</ScoreByQItem>
                </Column>
                <Column>
                  <ScoreByQItem>Q1</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.first}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.first}
                  </ScoreByQItem>
                </Column>
                <Column>
                  <ScoreByQItem>Q2</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.second}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.second}
                  </ScoreByQItem>
                </Column>
                <Column>
                  <ScoreByQItem>Q3</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.third}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.third}
                  </ScoreByQItem>
                </Column>
                <Column>
                  <ScoreByQItem>Q4</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.fourth}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.fourth}
                  </ScoreByQItem>
                </Column>
                <Column>
                  <ScoreByQItem>ET</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.fith}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.fith}
                  </ScoreByQItem>
                </Column>
                <Column>
                  <ScoreByQItem>Goals</ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.home?.goals}
                  </ScoreByQItem>
                  <ScoreByQItem>
                    {game?.scores_by_quarter?.away?.goals}
                  </ScoreByQItem>
                </Column>
              </ScoresByQ>
            </Row>
          )}

          <Row style={{ justifyContent: "space-between" }}>
            <Column style={{ width: "49%" }}>
              {game?.home_team?.name}
              <Team
                team_type="home"
                game={game}
                lineup={game?.lineup?.home || []}
                player_stats={homePlayerStats || game?.home_player_stats || []}
                supershot={supershot}
                updatePlayerStats={async ({
                  stats,
                  variable,
                  button,
                  supershot,
                }) => {
                  setHomePlayerStats(stats);
                  await updatePlayerStats({
                    id: game?._id,
                    team: "home",
                    stats,
                  });
                  if (variable === "goals" || variable === "supershots") {
                    local_scores_by_quarter =
                      local_scores_by_quarter || {
                        ...game?.scores_by_quarter,
                      } ||
                      {};
                    if (local_scores_by_quarter.game_id !== game?._id) {
                      local_scores_by_quarter =
                        { ...game?.scores_by_quarter } || {};
                    }
                    local_scores_by_quarter.game_id = game?._id;
                    let new_scores = JSON.parse(
                      JSON.stringify(local_scores_by_quarter),
                    );
                    if (!new_scores.home) {
                      new_scores.home = {};
                    }
                    let goals = supershot ? 2 : 1;
                    if (button === 0) {
                      if (quarter === 1) {
                        new_scores.home.first =
                          (local_scores_by_quarter?.home?.first || 0) + goals;
                      } else if (quarter === 2) {
                        new_scores.home.second =
                          (local_scores_by_quarter?.home?.second || 0) + goals;
                      } else if (quarter === 3) {
                        new_scores.home.third =
                          (local_scores_by_quarter?.home?.third || 0) + goals;
                      } else if (quarter === 4) {
                        new_scores.home.fourth =
                          (local_scores_by_quarter?.home?.fourth || 0) + goals;
                      } else if (quarter === 5) {
                        new_scores.home.fith =
                          (local_scores_by_quarter?.home?.fith || 0) + goals;
                      }
                    } else if (button === 2) {
                      if (quarter === 1) {
                        new_scores.home.first =
                          (local_scores_by_quarter?.home?.first || 0) - goals;
                      } else if (quarter === 2) {
                        new_scores.home.second =
                          (local_scores_by_quarter?.home?.second || 0) - goals;
                      } else if (quarter === 3) {
                        new_scores.home.third =
                          (local_scores_by_quarter?.home?.third || 0) - goals;
                      } else if (quarter === 4) {
                        new_scores.home.fourth =
                          (local_scores_by_quarter?.home?.fourth || 0) - goals;
                      } else if (quarter === 5) {
                        new_scores.home.fith =
                          (local_scores_by_quarter?.home?.fith || 0) - goals;
                      }
                    }
                    new_scores.home.goals =
                      (new_scores?.home?.first || 0) +
                      (new_scores?.home?.second || 0) +
                      (new_scores?.home?.third || 0) +
                      (new_scores?.home?.fourth || 0) +
                      (new_scores?.home?.fith || 0);
                    local_scores_by_quarter = new_scores;
                    updateGame({
                      id: game?._id,
                      scores_by_quarter: new_scores,
                    });
                  }
                }}
                updateLineup={updateLineup}
                updateGame={updateGame}
              />
              <Spacer />
            </Column>
            <Column style={{ width: "49%" }}>
              {game?.away_team?.name}
              <Team
                team_type="away"
                game={game}
                lineup={game?.lineup?.away || []}
                player_stats={awayPlayerStats || game?.away_player_stats || []}
                supershot={supershot}
                updatePlayerStats={async ({
                  stats,
                  variable,
                  button,
                  supershot,
                }) => {
                  setAwayPlayerStats(stats);
                  await updatePlayerStats({
                    id: game?._id,
                    team: "away",
                    stats,
                  });
                  if (variable === "goals" || variable === "supershots") {
                    local_scores_by_quarter =
                      local_scores_by_quarter || {
                        ...game?.scores_by_quarter,
                      } ||
                      {};

                    if (local_scores_by_quarter.game_id !== game?._id) {
                      local_scores_by_quarter =
                        { ...game?.scores_by_quarter } || {};
                    }
                    local_scores_by_quarter.game_id = game?._id;

                    let new_scores = JSON.parse(
                      JSON.stringify(local_scores_by_quarter),
                    );
                    if (!new_scores.away) {
                      new_scores.away = {};
                    }
                    let goals = supershot ? 2 : 1;
                    if (button === 0) {
                      if (quarter === 1) {
                        new_scores.away.first =
                          (local_scores_by_quarter?.away?.first || 0) + goals;
                      } else if (quarter === 2) {
                        new_scores.away.second =
                          (local_scores_by_quarter?.away?.second || 0) + goals;
                      } else if (quarter === 3) {
                        new_scores.away.third =
                          (local_scores_by_quarter?.away?.third || 0) + goals;
                      } else if (quarter === 4) {
                        new_scores.away.fourth =
                          (local_scores_by_quarter?.away?.fourth || 0) + goals;
                      } else if (quarter === 5) {
                        new_scores.away.fith =
                          (local_scores_by_quarter?.away?.fith || 0) + goals;
                      }
                    } else if (button === 2) {
                      if (quarter === 1) {
                        new_scores.away.first =
                          (local_scores_by_quarter?.away?.first || 0) - goals;
                      } else if (quarter === 2) {
                        new_scores.away.second =
                          (local_scores_by_quarter?.away?.second || 0) - goals;
                      } else if (quarter === 3) {
                        new_scores.away.third =
                          (local_scores_by_quarter?.away?.third || 0) - goals;
                      } else if (quarter === 4) {
                        new_scores.away.fourth =
                          (local_scores_by_quarter?.away?.fourth || 0) - goals;
                      } else if (quarter === 5) {
                        new_scores.away.fith =
                          (local_scores_by_quarter?.away?.fith || 0) - goals;
                      }
                    }
                    new_scores.away.goals =
                      (new_scores?.away?.first || 0) +
                      (new_scores?.away?.second || 0) +
                      (new_scores?.away?.third || 0) +
                      (new_scores?.away?.fourth || 0) +
                      (new_scores?.away?.fith || 0);
                    local_scores_by_quarter = new_scores;
                    updateGame({
                      id: game?._id,
                      scores_by_quarter: new_scores,
                    });
                  }
                }}
                updateLineup={updateLineup}
                updateGame={updateGame}
              />
            </Column>
          </Row>
        </Column>
      </PanelContent>
      <ConfirmModal
        title="Are you sure you want to delete data for this game?"
        show={confirmDelete}
        onConfirm={async () => {
          local_scores_by_quarter = {};
          setHomePlayerStats([]);
          setAwayPlayerStats([]);
          await updatePlayerStats({
            id: game?._id,
            team: "home",
            stats: game?.lineup?.home?.map((player) => {
              return { squad_id: player?.squad?._id };
            }),
          });
          await updatePlayerStats({
            id: game?._id,
            team: "away",
            stats: game?.lineup?.away?.map((player) => {
              return { squad_id: player?.squad?._id };
            }),
          });
          updateGame({
            id: game?._id,
            scores_by_quarter: {},
          });
          setConfirmDelete(false);
        }}
        onCancel={() => {
          setConfirmDelete(false);
        }}
      ></ConfirmModal>
    </Panel>
  );
}

function Team({
  lineup,
  player_stats,
  updatePlayerStats,
  updateLineup,
  game,
  team_type,
  supershot,
}) {
  const [subOff, setSubOff] = useState(null);
  const [subOn, setSubOn] = useState(null);

  function updateStat({ player, variable, e, supershot }) {
    let process = true;
    let newStat = [...JSON.parse(JSON.stringify(player_stats))];
    let index = newStat?.findIndex((p) => p.squad_id === player?.squad?._id);
    if (index === -1) {
      newStat.push({ squad_id: player?.squad?._id });
      index = newStat?.findIndex((p) => p.squad_id === player?.squad?._id);
    }
    if (e.button === 0) {
      newStat[index][variable] = (parseInt(player?.stats?.[variable]) || 0) + 1;
    } else if (e.button === 2) {
      if ((parseInt(player?.stats?.[variable]) || 0) - 1 >= 0) {
        newStat[index][variable] =
          (parseInt(player?.stats?.[variable]) || 0) - 1;
      } else {
        process = false;
      }
    }

    if (process) {
      updatePlayerStats({
        stats: newStat,
        variable,
        button: e.button,
        supershot,
      });
    }
  }
  function updatePosition({ player, variable, value }) {
    let newStat = [...JSON.parse(JSON.stringify(player_stats))];
    let index = newStat?.findIndex((p) => p.squad_id === player?.squad?._id);
    if (index === -1) {
      newStat.push({ squad_id: player?.squad?._id });
      index = newStat?.findIndex((p) => p.squad_id === player?.squad?._id);
    }

    newStat[index][variable] = value;

    updatePlayerStats({
      stats: newStat,
    });
  }
  return (
    <>
      <Table>
        <thead>
          <tr>
            <TH>
              <Tooltip>Sub</Tooltip>
            </TH>
            <TH>
              <Tooltip>POS</Tooltip>
            </TH>
            <TH>
              <Tooltip>NAME</Tooltip>
            </TH>
            {/* <TH>
              <Tooltip>L. NAME</Tooltip>
            </TH> */}
            {/* <TH>
              <Tooltip>Nat</Tooltip>
            </TH> */}

            <TH className={"stat"}>
              <Tooltip>
                G<TooltipText>Goals</TooltipText>
              </Tooltip>
            </TH>
            {supershot && (
              <TH className={"stat"}>
                <Tooltip>
                  SS<TooltipText>SuperShot</TooltipText>
                </Tooltip>
              </TH>
            )}
            <TH className={"stat"}>
              <Tooltip>
                M<TooltipText>Missed shots</TooltipText>
              </Tooltip>
            </TH>
            <TH className={"stat"}>
              <Tooltip>
                P<TooltipText>Penalties</TooltipText>
              </Tooltip>
            </TH>
            <TH className={"stat"}>
              <Tooltip>
                OR<TooltipText>Offensive rebounds</TooltipText>
              </Tooltip>
            </TH>
            <TH className={"stat"}>
              <Tooltip>
                DR<TooltipText>Defensive rebounds</TooltipText>
              </Tooltip>
            </TH>
            <TH className={"stat"}>
              <Tooltip>
                I<TooltipText>Intercepts</TooltipText>
              </Tooltip>
            </TH>
            <TH className={"stat"}>
              <Tooltip>
                D<TooltipText>Deflections</TooltipText>
              </Tooltip>
            </TH>
            <TH className={"stat"}>
              <Tooltip>
                T<TooltipText>Turnovers</TooltipText>
              </Tooltip>
            </TH>
            <TH className={"stat"}>
              <Tooltip>
                UE<TooltipText>Unforced errors</TooltipText>
              </Tooltip>
            </TH>
          </tr>
        </thead>
        <tbody>
          {[
            ...lineup
              ?.filter((p) => p.order <= 7)
              ?.sort((a, b) => {
                let stat_a = player_stats?.find(
                  (p) => p.squad_id === a?.squad?._id,
                );
                let stat_b = player_stats?.find(
                  (p) => p.squad_id === b?.squad?._id,
                );
                return (
                  POSITIONS_SORT[stat_a?.position] -
                  POSITIONS_SORT[stat_b?.position]
                );
              }),
            ...lineup?.filter((p) => p.order > 7),
          ].map((item, index) => {
            let l = item;

            let player = {
              _id: l?.squad?._id,
              ...l?.squad?.player,
              order: l?.order,
              shirt_number:
                l?.squad?.shirt_number || l?.squad?.opta_shirt_number,
              squad: l?.squad,
              yellow_card: l?.yellow_card,
              dbl_yellow_card: l?.dbl_yellow_card,
              red_card: l?.red_card,
              sub_order: l?.sub_order,
              subbed: l?.subbed,
              captain: l?.captain,
              stats: player_stats?.find((p) => p.squad_id === l?.squad?._id),
            };

            return (
              <tr
                style={{
                  opacity: player.order > 7 ? 0.6 : 1,
                }}
                className={index === 7 ? "subs" : ""}
              >
                <td
                  style={{
                    textAlign: "center",
                  }}
                >
                  {subOn === player._id && (
                    <IoIosArrowUp style={{ color: "green" }} />
                  )}
                  {subOff === player._id && (
                    <IoIosArrowDown style={{ color: "red" }} />
                  )}
                  {((player.order > 7 && !subOn) ||
                    (player.order <= 7 && !subOff)) && (
                    <SubButton
                      onClick={async () => {
                        debugger;
                        let local_sub_off = subOff;
                        let local_sub_on = subOn;

                        if (player.order <= 7) {
                          local_sub_off = player._id;
                          setSubOff(player._id);
                        }
                        if (player.order > 7) {
                          local_sub_on = player._id;
                          setSubOn(player._id);
                        }
                        let new_lineup = JSON.parse(
                          JSON.stringify(game.lineup),
                        );
                        let subOnPlayer = {
                          ...game.lineup[team_type].find(
                            (p) => p.squad?.player?._id === local_sub_on,
                          ),
                        };
                        let subOffPlayer = {
                          ...game.lineup[team_type].find(
                            (p) => p.squad?.player?._id === local_sub_off,
                          ),
                        };

                        let on_index = new_lineup[team_type].findIndex(
                          (p) => p.squad?.player?._id === local_sub_on,
                        );
                        let off_index = new_lineup[team_type].findIndex(
                          (p) => p.squad?.player?._id === local_sub_off,
                        );
                        if (on_index > -1 && off_index > -1) {
                          new_lineup[team_type][on_index].order =
                            subOffPlayer.order;
                          new_lineup[team_type][off_index].order =
                            subOnPlayer.order;
                          await updateLineup({
                            id: game._id,
                            lineup: new_lineup,
                          });
                          setSubOn(null);
                          setSubOff(null);
                          updatePosition({
                            player: subOnPlayer,
                            variable: "position",
                            value: player_stats?.find(
                              (p) => p.squad_id === subOffPlayer?.squad?._id,
                            )?.position,
                          });
                        }
                      }}
                    >
                      {player.order <= 7 ? "Off" : "On"}
                    </SubButton>
                  )}
                </td>
                <td class="position">
                  <div style={{ width: "105px" }}>
                    <SelectUI
                      value={
                        (player?.stats?.position && {
                          value: player?.stats?.position,
                          label: POSITIONS[player?.stats?.position],
                        }) ||
                        null
                      }
                      options={Object.keys(POSITIONS)?.map((key) => {
                        return { label: POSITIONS[key], value: key };
                      })}
                      placeholder=""
                      onChange={(position) => {
                        updatePosition({
                          player,
                          variable: "position",
                          value: position,
                        });
                      }}
                    />
                  </div>
                </td>
                <td>
                  {player?.first_name} {player?.last_name}
                </td>
                {/* <td>{player?.last_name}</td> */}
                {/* <td>
                  {player?.nationality?.code || player?.nationality?.sotic_code}
                </td> */}
                <td
                  className={"stat"}
                  onContextMenu={(e) => e.preventDefault()}
                  onMouseDown={(e) => {
                    updateStat({
                      player,
                      variable: "goals",
                      e,
                      supershot: false,
                    });
                  }}
                >
                  {player?.stats?.goals || "-"}
                </td>
                {supershot && (
                  <td
                    className={"stat"}
                    onContextMenu={(e) => e.preventDefault()}
                    onMouseDown={(e) => {
                      updateStat({
                        player,
                        variable: "supershots",
                        e,
                        supershot: true,
                      });
                    }}
                  >
                    {player?.stats?.supershots || "-"}
                  </td>
                )}
                <td
                  className={"stat"}
                  onContextMenu={(e) => e.preventDefault()}
                  onMouseDown={(e) => {
                    updateStat({ player, variable: "missed_shots", e });
                  }}
                >
                  {player?.stats?.missed_shots || "-"}
                </td>
                <td
                  className={"stat"}
                  onContextMenu={(e) => e.preventDefault()}
                  onMouseDown={(e) => {
                    updateStat({ player, variable: "penalties", e });
                  }}
                >
                  {player?.stats?.penalties || "-"}
                </td>
                <td
                  className={"stat"}
                  onContextMenu={(e) => e.preventDefault()}
                  onMouseDown={(e) => {
                    updateStat({ player, variable: "rebounds_offensive", e });
                  }}
                >
                  {player?.stats?.rebounds_offensive || "-"}
                </td>
                <td
                  className={"stat"}
                  onContextMenu={(e) => e.preventDefault()}
                  onMouseDown={(e) => {
                    updateStat({ player, variable: "rebounds_defensive", e });
                  }}
                >
                  {player?.stats?.rebounds_defensive || "-"}
                </td>
                <td
                  className={"stat"}
                  onContextMenu={(e) => e.preventDefault()}
                  onMouseDown={(e) => {
                    updateStat({ player, variable: "intercepts", e });
                  }}
                >
                  {player?.stats?.intercepts || "-"}
                </td>
                <td
                  className={"stat"}
                  onContextMenu={(e) => e.preventDefault()}
                  onMouseDown={(e) => {
                    updateStat({ player, variable: "deflections", e });
                  }}
                >
                  {player?.stats?.deflections || "-"}
                </td>
                <td
                  className={"stat"}
                  onContextMenu={(e) => e.preventDefault()}
                  onMouseDown={(e) => {
                    updateStat({ player, variable: "turnovers", e });
                  }}
                >
                  {player?.stats?.turnovers || "-"}
                </td>
                <td
                  className={"stat"}
                  onContextMenu={(e) => e.preventDefault()}
                  onMouseDown={(e) => {
                    updateStat({ player, variable: "unforced_errors", e });
                  }}
                >
                  {player?.stats?.unforced_errors || "-"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
      {(subOn || subOff) && (
        <Button
          onClick={() => {
            setSubOn(null);
            setSubOff(null);
          }}
        >
          Cancel Subs
        </Button>
      )}
    </>
  );
}

export default Logging;
